module.exports = __webpack_public_path__ + "img/1023.357852c6.png";